// UI strings for "Kuka teki kenelle?" (roles/; engine pedagogy/role-swap.ts): read who does what to
// whom off the case ending, then pick the Finnish meaning. The round (Vapaa harjoitus, Harjoittele
// viikkoa N), the lesson block <KukaTeki /> and the door on Tänään. Style: docs/FINNISH-STYLE.md
// (sinä-muoto, no jargon, no intro text).
import { defineArea } from '../area';

export const rolesFi = {
  title: 'Kuka teki kenelle?',
  /** The door's second line (Tänään, Vapaa harjoitus, the week's options). */
  doorDetail: 'lue roolit päätteistä · noin 3 min',
  /** Over the two meanings. */
  ask: 'Mitä lause tarkoittaa?',
  /** One line under the choices: what to look at. */
  hint: 'Katso korostettuja päätteitä.',
  right: 'Oikein.',
  wrong: 'Ei aivan.',
  /** Under the answer: the right meaning when the other was chosen. */
  meant: (fi: string) => `Lause tarkoittaa ”${fi}”`,
  position: (i: number, n: number) => `${i}/${n}`,
  next: 'Seuraava',
  done: 'Valmis',
  score: (k: number, n: number) => `${k}/${n} oikein`,
  again: 'Uusi kierros',
  more: 'Lisää lauseita',
  weekScope: (n: number) => `Viikko ${n}`,
  loading: 'Ladataan…',
  /** No sentence yet whose words you have opened. */
  empty: 'Lauseita ei vielä ole: niiden sanat avautuvat myöhemmillä oppitunneilla.',
  emptyWeek: (n: number) => `Viikolta ${n} ei vielä ole lauseita.`,
  allWeeks: 'Kaikki viikot',
  back: 'Vapaa harjoitus',
};

export const rolesEn: typeof rolesFi = {
  title: 'Who did what to whom?',
  doorDetail: 'read the roles off the endings · about 3 min',
  ask: 'What does the sentence mean?',
  hint: 'Look at the highlighted endings.',
  right: 'Right.',
  wrong: 'Not quite.',
  meant: (fi: string) => `The sentence means “${fi}”`,
  position: (i: number, n: number) => `${i}/${n}`,
  next: 'Next',
  done: 'Done',
  score: (k: number, n: number) => `${k}/${n} right`,
  again: 'New round',
  more: 'More sentences',
  weekScope: (n: number) => `Week ${n}`,
  loading: 'Loading…',
  empty: 'No sentences yet: their words open in later lessons.',
  emptyWeek: (n: number) => `No sentences from week ${n} yet.`,
  allWeeks: 'All weeks',
  back: 'Free practice',
};

export const area = defineArea('roles', rolesFi, rolesEn);

declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof rolesFi> {}
}
